module.exports = __webpack_public_path__ + "img/terroir-tinted-2-mobile.d61e116c.jpg";